import React from 'react'
import PropTypes from 'prop-types'

const OfferSearchShortTitle = ({ trainingShortTitle, trainingShortTitleHeadline, className, titleClassName }) => {
  return (
    <div className={`pb-16 ${className}`}>
      <p className={`pr-4 ${titleClassName}`}>{trainingShortTitleHeadline}</p>
      <p>{trainingShortTitle}</p>
    </div>
  )
}

OfferSearchShortTitle.propTypes = {
  trainingShortTitle: PropTypes.string,
  trainingShortTitleHeadline: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
}

OfferSearchShortTitle.defaultProps = {
  trainingShortTitleHeadline: 'Kursnummer',
  className: '',
  titleClassName: '',
}

export default OfferSearchShortTitle
